const FunkityLogo: React.FC<React.SVGProps<SVGElement>> = props => (
  <svg
    fill="none"
    viewBox="0 0 1402 388"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(props as any)}
  >
    <g clipPath="url(#clip0_7_637)">
      <mask
        height="388"
        id="mask0_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask0_7_637)">
        <path
          d="M348.552 204.943c0 11.061-2.912 19.856-8.721 26.376-5.816 6.528-13.827 9.785-24.035 9.785q-9.793 0-17.231-4.467-7.448-4.466-11.485-12.55c-2.7-5.384-4.043-11.766-4.043-19.144V92.632h-68.068v112.311c0 19.856 4.322 37.437 12.976 52.752q12.971 22.976 35.736 35.948c15.17 8.656 32.544 12.976 52.115 12.976 19.847 0 37.288-4.32 52.325-12.976q22.54-12.972 35.523-35.948c8.648-15.315 12.975-32.896 12.975-52.752V92.632h-68.067z"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask1_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask1_7_637)">
        <path
          d="M610.181 99.865q-19.145-11.487-45.945-11.487c-14.751 0-27.514 4.328-38.29 12.975q-8.117 6.517-14.462 15.711V92.631h-68.068v209.734h68.068V193.457q0-17.865 9.57-28.503c6.382-7.085 14.818-10.636 25.314-10.636 10.488 0 18.93 3.551 25.312 10.636q9.572 10.638 9.572 28.503v108.908h68.492V184.523q0-30.2-10.21-51.688c-6.806-14.32-16.592-25.313-29.353-32.97"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask2_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask2_7_637)">
        <path
          d="M892.652 92.631h-83.381l-64.239 83.546V4.57h-68.068v297.795h68.068v-90.21l67.216 90.21h87.211l-87.636-108.058z"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask3_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask3_7_637)">
        <path d="M911.792 302.365h68.067V92.632h-68.067z" fill="currentColor"></path>
      </g>
      <mask
        height="388"
        id="mask4_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask4_7_637)">
        <path
          d="M1109.61 39.029h-68.07V92.63h-38.29v65.516h38.29v54.879c0 19.291 3.62 35.881 10.85 49.775q10.845 20.847 30.21 31.906c12.9 7.379 28 11.062 45.3 11.062 4.54 0 9.85-.287 15.96-.852 6.09-.572 11.27-1.422 15.52-2.552v-62.963q-3.405.858-7.65 1.276c-2.84.287-5.53.427-8.09.427-9.35 0-17.37-2.407-24.03-7.232-6.67-4.82-10-12.192-10-22.123v-53.603h49.77V92.631h-49.77z"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask5_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask5_7_637)">
        <path
          d="M1328.05 92.631 1287.7 202.16l-40.48-109.528h-73.17l78.56 189.1-47.93 105.718h73.59l123.38-294.818z"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask6_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask6_7_637)">
        <path
          d="M137.78 109.139c-27.832 0-50.394 22.561-50.394 50.393s22.562 50.394 50.394 50.394 50.393-22.562 50.393-50.394-22.561-50.393-50.393-50.393"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask7_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65v387.449H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask7_7_637)">
        <path
          d="M154.962 4.57H77.481C34.689 4.57 0 39.26 0 82.053v232.443c42.792 0 77.48-34.69 77.48-77.482V73.979h116.222V4.57z"
          fill="currentColor"
        ></path>
      </g>
      <mask
        height="388"
        id="mask8_7_637"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="1402"
        x="0"
        y="0"
      >
        <path d="M0 0h1401.65V387.45H0z" fill="#fff"></path>
      </mask>
      <g mask="url(#mask8_7_637)">
        <path
          d="M945.824 0c-19.236 0-34.829 15.594-34.829 34.83s15.593 34.829 34.829 34.829 34.83-15.593 34.83-34.83C980.654 15.595 965.06 0 945.824 0"
          fill="currentColor"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7_637">
        <path d="M0 0h1401.64v387.449H0z" fill="#fff"></path>
      </clipPath>
    </defs>
  </svg>
)

export default FunkityLogo
